/* eslint-disable */
/*!
   _____ ______ __  __ _    _  _____ __  __ ______ _____  
  / ____|  ____|  \/  | |  | |/ ____|  \/  |  ____|  __ \ 
 | |  __| |__  | \  / | |__| | (___ | \  / | |__  | |  | |
 | | |_ |  __| | |\/| |  __  |\___ \| |\/| |  __| | |  | |
 | |__| | |____| |  | | |  | |____) | |  | | |____| |__| |
  \_____|______|_|  |_|_|  |_|_____/|_|  |_|______|_____/                                                                                                                                                                                                                                                                                                   
=========================================================
* GEMHSMED UI - v2.0.0
=========================================================

* Copyright 2024 GEMHS (https://gemhs.net/)

* Designed and Coded by GEMHS

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software. 

*/

import React from "react";
import {
    Box,
    Text,
    Button,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    useDisclosure,
    Link,
    OrderedList,
    ListItem
} from "@chakra-ui/react";

const License = () => {
    const {
        isOpen: isOpenA,
        onOpen: onOpenA,
        onClose: onCloseA,
    } = useDisclosure();
    const {
        isOpen: isOpenB,
        onOpen: onOpenB,
        onClose: onCloseB,
    } = useDisclosure();

    return (
        <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
            <Text fontSize={25} fontWeight="bold" mt={6}>
                Licensing and Usage
            </Text>
            <Text mt={4}>
                This License Agreement (the "Agreement") is made and entered
                into on this <strong><em>[date]</em></strong> by and between GEMHS, a business
                corporation, with its principal place of business at Kingstown
                ("Developer"), and <strong><em>[client]</em></strong>, a business corporation,
                with its principal place of business at <strong><em>[location_of_client]</em></strong> 
                ("User"). 

                
            </Text>

            <Text mt={4}><span>WHEREAS, Developer has developed certain software (the
                "Software") which is subject to intellectual property
                protection, and</span> </Text>

            
            <Text mt={4}><span>WHEREAS, Developer desires to license the
                Software to User for use pursuant to the terms and conditions
                set forth in this Agreement, and</span> </Text>

            <Text mt={4}><span>WHEREAS, User desires to obtain
                a license to use the Software in accordance with the terms and
                conditions set forth in this Agreement.</span> </Text>

            <Text mt={4}><span>NOW, THEREFORE, for good
                and valuable consideration, the receipt and sufficiency of which
                is hereby acknowledged, Developer and User agree as follows:</span></Text>

            <OrderedList p={4}>
                    <ListItem>
                        <Text as="span">
                            <strong>License Grant.</strong> Subject to the terms and conditions
                            set forth in this Agreement, Developer grants to
                            User a non-exclusive, non-transferable, limited
                            license to use the Software solely for User's
                            internal business purposes.
                        </Text>
                    </ListItem>
                    <ListItem mt={1}>
                        <Text as="span">
                            <strong>Restrictions on Use.</strong> User shall not use the Software
                            except as expressly permitted in this Agreement.
                            User shall not: copy, modify, or create derivative
                            works of the Software, reverse engineer, decompile,
                            or disassemble the Software, distribute, sell,
                            sublicense, or otherwise transfer the Software to
                            any third party, or use the Software in any manner
                            that violates any applicable law or regulation.
                        </Text>
                    </ListItem>
                    <ListItem mt={1}>
                        <Text as="span">
                            <strong>Payment.</strong> User shall pay Developer the license fee
                            set forth in{" "}
                            <Link
                                as="button"
                                color="blue.500"
                                onClick={onOpenA}
                            >
                                Exhibit A
                            </Link>{" "}
                            attached hereto and incorporated herein by
                            reference. The license fee is non-refundable and
                            shall be paid in full by User within two (2) days of
                            the Effective Date of this Agreement.
                        </Text>
                    </ListItem>
                    <ListItem mt={1}>
                        <Text as="span">
                            <strong>Term and Termination.</strong> This Agreement shall commence
                            on the Effective Date and shall continue in effect
                            for a period of one (1) month, unless earlier
                            terminated as provided herein. Either party may
                            terminate this Agreement upon seven (7) days'
                            written notice to the other party in the event of a
                            material breach of this Agreement by the other
                            party. Upon termination of this Agreement, User
                            shall immediately cease using the Software and shall
                            return all copies of the Software to Developer.
                        </Text>
                    </ListItem>
                    <ListItem mt={1}>
                        <Text as="span">
                            <strong>Ownership of Intellectual Property.</strong> User
                            acknowledges that Developer is the sole and
                            exclusive owner of all intellectual property rights
                            in the Software, and that User shall not acquire any
                            ownership interest in the Software or any portion
                            thereof.
                        </Text>
                    </ListItem>
                    <ListItem mt={1}>
                        <Text as="span">
                            <strong>Confidentiality.</strong> User acknowledges that the Software
                            contains confidential and proprietary information of
                            Developer. User shall maintain the confidentiality
                            of the Software and shall not disclose the Software
                            or any information related thereto to any third
                            party without the prior written consent of
                            Developer.
                        </Text>
                    </ListItem>
                    <ListItem mt={1}>
                        <Text as="span">
                            <strong>Warranties and Limitation of Liability.</strong> Developer
                            warrants that the Software shall perform in material
                            conformity with the specifications set forth in{" "}
                            <Link
                                as="button"
                                color="blue.500"
                                onClick={onOpenB}
                            >
                                Exhibit B
                            </Link>{" "}
                            attached hereto and incorporated herein by
                            reference. Developer makes no other warranties,
                            express or implied, including but not limited to
                            warranties of merchantability, fitness for a
                            particular purpose, or non-infringement. In no event
                            shall Developer be liable for any indirect,
                            incidental, special, or consequential damages
                            arising out of or in connection with this Agreement,
                            even if Developer has been advised of the
                            possibility of such damages.
                        </Text>
                    </ListItem>
                    <ListItem mt={1}>
                        <Text as="span">
                            <strong>Governing Law; Jurisdiction.</strong> This Agreement shall be
                            governed by and construed in accordance with the
                            laws of the State of St Vincent & the Grenadines,
                            without giving effect to any choice or conflict of
                            law provision or rule. User and Developer agree that
                            any action arising out of or related to this
                            Agreement shall be brought exclusively in the state
                            or federal courts located in St Vincent & the
                            Grenadines, and User and Developer hereby submit to
                            the personal jurisdiction of such courts.
                        </Text>
                    </ListItem>
                    <ListItem mt={1}>
                        <Text as="span">
                            <strong>Entire Agreement; Amendment.</strong> This Agreement
                            constitutes the entire agreement between the parties
                            with respect to the subject matter hereof and
                            supersedes all prior or contemporaneous agreements
                            or understandings, whether oral or written. This
                            Agreement may not be amended or modified except in
                            writing signed by both parties.
                        </Text>
                    </ListItem>
                </OrderedList>

                <Text mt={4}>
                <i>IN WITNESS WHEREOF</i>, the parties have executed this Agreement as
                of the date first above written.
                </Text>

            {/* Modal for Exhibit A */}
            <Modal isOpen={isOpenA} onClose={onCloseA} isCentered>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Exhibit A - License Fee Details</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <Text>
                            The license fee is non-refundable and shall be paid
                            in full by User within two (2) days of the Effective
                            Date of this Agreement.
                        </Text>
                    </ModalBody>
                    <ModalFooter>
                        <Button colorScheme="blue" mr={3} onClick={onCloseA}>
                            Close
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>

            {/* Modal for Exhibit B */}
            <Modal isOpen={isOpenB} onClose={onCloseB} isCentered>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>
                        Exhibit B - Software Specifications
                    </ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <Text>
                            Software shall perform in material conformity with
                            the specifications detailed herein. Specific
                            performance metrics and capabilities are outlined.
                        </Text>
                    </ModalBody>
                    <ModalFooter>
                        <Button colorScheme="blue" mr={3} onClick={onCloseB}>
                            Close
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </Box>
    );
};

export default License;
